export const cropString = (
  string: string,
  config: { maxLength?: number; endingIfCropped?: string } = {}
) => {
  const { maxLength = 0, endingIfCropped = "..." } = config;
  return string.length > maxLength
    ? string.slice(0, maxLength) + endingIfCropped
    : string;
};
